import useGet from '../../../hooks/useGet';
const useStatusGlossary = () => {
    const { error, loading, data, } = useGet({
        url: '/status-service/customer/statusGlossary',
        options: {
            params: {
                applicationInternalName: 'STATUS_ER'
            }
        }
    });
    return {
        glossary: data,
        loading,
        error,
    };
};
export default useStatusGlossary;
